<template>
  <div>
  <shift-edit-dialog
    ref="shiftEditDialog"
    @update="editDone"
    @delete="deleteDone"
    :shops="shops"
    :currentShop="currentShop"
    :items="items"
    :staffs="staffs"
    :year="year"
    :month="month" />
  <shift-apply-dialog
    @applied="fetchData"
    ref="shiftApplyDialog" />
  <h1>
   <el-button icon="el-icon-caret-left" @click="goPrevMonth"></el-button>
   {{ year }}年 {{ month }}月 シフト予定入力ページ
   <el-button icon="el-icon-caret-right" @click="goNextMonth"></el-button>
  </h1>
  <div class="search-area">
    <el-tooltip :disabled="!prevShop" placement="top" :content="prevShop ? prevShop.name : null">
      <el-button icon="el-icon-caret-left" :disabled="!prevShop || isLoading" @click="shop=prevShop.pk;fetchData()"></el-button>
    </el-tooltip>
    <el-select v-model="shop" @change="shopChange">
      <el-option
        v-for="s in shops"
        :key="s.pk"
        :label="s.name"
        :value="s.pk">
      </el-option>
    </el-select>
    <el-tooltip :disabled="!nextShop" placement="top" :content="nextShop ? nextShop.name : null">
      <el-button icon="el-icon-caret-right" :disabled="!nextShop || isLoading" @click="shop=nextShop.pk;fetchData()"></el-button>
    </el-tooltip>
    <el-button @click="refresh">再読込</el-button>
    <el-tooltip v-show="currentShop" placement="top" content="テーブルの表示列を変更できます">
      <el-button type="success" @click="isShown=true">表示変更</el-button>
    </el-tooltip>
    <el-tooltip v-show="currentShop" placement="top" content="表をダブルクリックしても登録できます">
      <el-button type="primary" @click="editPlanWithoutStaff">シフト登録</el-button>
    </el-tooltip>
    <el-tooltip placement="top" content="確認済みのシフト予定をシフト登録します">
      <el-button :disabled="disableApply" type="danger" @click="showShiftApplyDialog">シフト適用</el-button>
    </el-tooltip>
    <el-alert type="warning" title="">
      6時間以上勤務：50分休憩を入力. 8時間以上勤務：60分休憩を入力
    </el-alert>
    <div v-if="shopData">
      {{ shopData.name }}
      開店時間: {{ shopData.defaultOpenTime }}
      閉店時間: {{ shopData.defaultCloseTime }}

      合計労働時間: {{ monthlyWorkingHour | locale }}

      上限労働時間/月:
      <span v-if="monthlyWorkingHourLimitation === null">未設定</span>
      <span v-else>{{ monthlyWorkingHourLimitation | locale(undefined, {maximumFractionDigits: 1}) }}h</span>

      上限労働時間/日:
      <span v-if="dailyWorkingHourLimitation === null">未設定</span>
      <span v-else>{{ dailyWorkingHourLimitation | locale(undefined, {maximumFractionDigits: 1}) }}h</span>

      上限人数:
      <span v-if="staffCountLimitation === null">未設定</span>
      <span v-else>{{ staffCountLimitation }}人</span>

      <el-alert
        v-if="monthlyWorkingHourLimitation < monthlyWorkingHour"
        title="error"
        type="error">
        月労働時間の上限を超えています。
        上限: {{ monthlyWorkingHourLimitation }} &lt; 合計: {{ monthlyWorkingHour }}
      </el-alert>

      <el-alert
        v-if="hasStaffOverflow"
        title="error"
        type="error">
        スタッフ数の上限を超えてる日があります。
      </el-alert>
    </div>
  </div>
  <el-dialog :visible.sync="isShown" title="表示項目設定" width="80%">
    <el-form>
      <el-form-item>
        <el-checkbox v-model="showOpenCloseTime">開店／閉店時間を表示</el-checkbox>
        <el-checkbox v-model="showHelpPlan">応援を表示</el-checkbox>
      </el-form-item>
      <el-form-item>
        <el-button @click="narrowStaff('inputOnly')">入力済み</el-button>
        <el-button @click="narrowStaff('myShop')">所属店舗</el-button>
      </el-form-item>
      <el-form-item>
        <el-transfer
          class="staff-select"
          filterable
          v-model="checkedStaffs"
          :data="transferStaffs"
          :titles="['非表示', '表示中']">
        </el-transfer>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="isShown=false" type="primary">閉じる</el-button>
    </div>
  </el-dialog>
  <div class="data-area">
    <el-table
      border
      ref="shiftPlanTable"
      class="shift-plan-table"
      :row-class-name="rowClass"
      :height="tableHeight"
      :data="items"
      v-loading="isLoading">
      <el-table-column
        label="日付"
        prop="date"
        fixed="left"
        :formatter="printDate"
        align="center"
        width="70">
      </el-table-column>
      <el-table-column
        width="60"
        label="開店時間"
        align="center"
        v-if="showOpenCloseTime"
        fixed="left"
        prop="openTime">
      </el-table-column>
      <el-table-column
        width="60"
        label="閉店時間"
        v-if="showOpenCloseTime"
        align="center"
        fixed="left"
        prop="closeTime">
      </el-table-column>
      <el-table-column
        width="60"
        label="開店人数"
        align="right"
      >
        <template slot-scope="scope">
          <div>{{ openingStaffNum(scope.row) }}</div>
        </template>
      </el-table-column>
      <el-table-column
        width="60"
        label="閉店人数"
        align="right"
      >
        <template slot-scope="scope">
          <div>{{ closingStaffNum(scope.row) }}</div>
        </template>
      </el-table-column>
      <el-table-column
        width="60"
        label="最大人数"
        align="right"
      >
        <template slot-scope="scope">
          <div>{{ maxStaffCount(scope.row) }}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="総労働時間"
        align="right"
        width="75"
      >
        <template slot-scope="scope">
          <div>{{ workingTime(scope.row) | locale(undefined, {minimumFractionDigits: 1, maximumFractionDigits: 1}) }}h</div>
        </template>
      </el-table-column>
      <el-table-column
        label="超過判定"
        align="center"
        width="60">
        <template slot-scope="scope">
          <el-tag type="success" v-if="!isOver(scope.row)"><i class="el-icon-check"></i></el-tag>
          <el-tag type="danger" v-else><i class="el-icon-error"></i></el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="店長確認"
        align="center"
        width="60">
        <template slot-scope="scope">
          <div v-if="applieds[scope.row.date]">
            適用済
          </div>
          <template v-else>
            <div>
              <el-select
                v-model="statuses[scope.row.date]"
                class="shift-plan-status"
                :class="shiftPlanStatusClass(scope.row)"
                no-match-text="未確認"
                no-data-text="未確認"
                placeholder="未確認"
                :disabled="!hasManagerAuthority"
                @change="changeStatus(scope.row, $event)"
                size="mini">
                <el-option :value="ShiftPlanStatus.CHECKED" label="確認済"></el-option>
                <el-option :value="ShiftPlanStatus.SHORTAGE" label="不足"></el-option>
                <el-option :value="ShiftPlanStatus.OVERAGE" label="超過"></el-option>
                <el-option :value="ShiftPlanStatus.PENDDING" label="保留"></el-option>
              </el-select>
            </div>
          </template>
        </template>
      </el-table-column>
      <template v-for="(header, index) in headers">
        <el-table-column
          :key="index"
          align="center"
          v-if="showStaffColumn(header.staff)"
          :label="header.label">
          <el-table-column
            align="right"
            width="100"
            class-name="working-time"
            label="勤務時間">
            <template slot-scope="scope">
              <div @dblclick="editPlan(scope.row.date, header.staff)" v-html="printPlan(scope.row, header.staff) "></div>
            </template>
          </el-table-column>
          <el-table-column
            align="right"
            v-if="showHelpPlan"
            width="100"
            class-name="working-time"
            label="応援">
            <template slot-scope="scope">
              <div v-html="printHelpPlan(scope.row, header.staff)"></div>
            </template>
          </el-table-column>
        </el-table-column>
      </template>
    </el-table>
  </div>
  </div>
</template>

<script>
import ShopType from '@/consts/ShopType'
import moment from 'moment'
import ShiftEditDialog from './EditDialog'
import ShiftApplyDialog from './ShiftApplyDialog'
import StaffLoginDialog from '@/components/Account/StaffLoginDialog'
import zeroPadding from '@/misc/zeroPadding'
import {mapGetters} from 'vuex'
import {debounce} from 'lodash'
import ShiftPlanStatus from '@/consts/ShiftPlanStatus'

const LOCAL_STORAGE_KEY = 'shiftPlan_0.3'

function combineDatetime (date, h, m) {
  return moment(date).add('hours', Number(h)).add('minutes', Number(m))
}

export default {
  name: 'ShiftPlanIndex',
  components: {
    ShiftApplyDialog,
    ShiftEditDialog,
    StaffLoginDialog,
  },
  props: {
    year: {
      type: [Number, String],
      required: false,
    },
    month: {
      type: [Number, String],
      required: false,
    },
  },
  data () {
    const self = this
    return {
      isShown: false,
      isLoading: false,
      showOpenCloseTime: true,
      showHelpPlan: true,
      items: [],
      staffs: [],
      checkedStaffs: [],
      shops: [],
      currentShop: null,
      headers: [],
      shop: null,
      staffData: {
        role: null,
      },
      ShiftPlanStatus,
      narrow: 'all',
      windowState: {width: 0, height: 0, navHeight: 0},
      debouncedOnResize: debounce(function () {
        const nav = document.querySelector('header')
        if (nav) {
          self.windowState.navHeight = nav.scrollHeight
        }
        self.windowState.width = document.documentElement.clientWidth
        self.windowState.height = document.documentElement.clientHeight
      }, 200),
      statuses: {},
      checks: {},
      applieds: {},
    }
  },
  computed: {
    ...mapGetters({
      selectedShop: 'shop',
    }),
    ...mapGetters(['hasManagerAuthority', 'superuserLoggedIn', 'adminLoggedIn']),
    transferStaffs () {
      return this.staffs.map(staff => {
        return {
          key: staff.pk,
          label: `${staff.name}(${staff.shopName})`,
        }
      })
    },
    tableHeight () {
      return this.windowState.height - 250
    },
    shopData () {
      return this.shops.find(shop => shop.pk === this.shop)
    },
    currentShopData () {
      return this.shops.find(shop => shop.pk === this.currentShop)
    },
    prevShop () {
      if (this.shop === null) {
        return null
      }
      let index = this.shops.findIndex(x => x.pk === this.shop)
      if (index <= 0) {
        return null
      }
      return this.shops[index - 1]
    },
    nextShop () {
      if (this.shop === null) {
        return this.shops.length ? this.shops[0] : null
      }
      let index = this.shops.findIndex(x => x.pk === this.shop)
      if (index === -1) {
        return null
      }
      if (this.shops.length > index + 1) {
        return this.shops[index + 1]
      }
      return null
    },
    filteredStaffs () {
      let ret = []
      if (this.narrow === 'inputOnly') {
        this.staffs.forEach(staff => {
          let found = this.items.some(tmp => tmp.plans.some(plan => plan.staff === staff.pk))
          if (found) {
            ret.push(staff)
          }
        })
      } else if (this.narrow === 'myShop') {
        ret = this.staffs.filter(x => x.shop === this.shop)
      } else {
        ret = this.staffs
      }
      const shop = this.shop
      const sFunc = function (a, b) {
        // 所属店舗の場合は一番上にする
        // 店舗が異なる場合は店舗コードで並び替える
        // 店舗が同じ場合はコード順で並び替える
        if (a.shop === shop && b.shop !== shop) {
          return -1
        } else if (a.shop !== shop && b.shop === shop) {
          return 1
        }
        if (a.shop !== b.shop) {
          return parseInt(a.shopCode) > parseInt(b.shopCode) ? 1 : -1
        }
        return (parseInt(a.code) > parseInt(b.code)) ? 1 : -1
      }
      return ret.sort(sFunc)
    },
    monthlyWorkingHourLimitation () {
      let shop = this.shopData
      if (!shop) return null
      return shop.monthlyWorkingHoursLimitation
    },
    staffCountLimitation () {
      let shop = this.shopData
      if (!shop) return null
      return shop.staffCountLimitation
    },
    dailyWorkingHourLimitation () {
      let limitMonthly = this.monthlyWorkingHourLimitation
      let days = this.items.length
      if (limitMonthly === null) return null
      if (days === 0) return null
      return limitMonthly / days
    },
    monthlyWorkingHour () {
      let minutes = this.items.map(item => item
        .plans
        .filter(plan => !plan.isVacation && !plan.isPaidVacation && plan.workMinutes)
        .map(plan => plan.workMinutes).reduce((a, b) => a + b, 0)).reduce((a, b) => a + b, 0)
      return minutes / 60
    },
    disableApply () {
      if (this.adminLoggedIn) return false
      // NOTE: 2019/08/02 中塚さんの依頼で一時的に超過のあるなし関係なしに管理者以上でないとシフト適用できないようにした。
      return true
      // return this.monthlyWorkingHourLimitation < this.monthlyWorkingHour || this.hasStaffOverflow
    },
    hasStaffOverflow () {
      let limitStaff = this.staffCountLimitation
      if (limitStaff !== null) {
        return this.items.map(this.maxStaffCount).filter(cnt => cnt > limitStaff).length > 0
      }
      return false
    },
  },
  watch: {
    '$route' () {
      this.fetchData()
    },
  },
  mounted () {
    // if (!this.loadState() || !this.shops.length) {
    this.fetchShopData()
    // }
    window.addEventListener('resize', this.debouncedOnResize, false)
    window.addEventListener('beforeunload', () => {
      this.saveState()
    })
    this.debouncedOnResize()
  },
  destroyed () {
    window.removeEventListener('resize', this.debouncedOnResize, false)
    this.saveState()
  },
  methods: {
    goPrevMonth () {
      let tmp = moment().year(this.year).month(this.month - 1).set('date', 10).subtract(1, 'months')
      const params = {
        year: tmp.year(),
        month: tmp.month() + 1,
      }
      this.$router.push({
        name: 'ShiftPlanIndex',
        params,
      })
    },
    goNextMonth () {
      let tmp = moment().year(this.year).month(this.month - 1).set('date', 10).add(1, 'months')
      const params = {
        year: tmp.year(),
        month: tmp.month() + 1,
      }
      this.$router.push({
        name: 'ShiftPlanIndex',
        params,
      })
    },
    saveState () {
      let data = {
        'showOpenCloseTime': this.showOpenCloseTime,
        'showHelpPlan': this.showHelpPlan,
        'items': this.items,
        'shops': this.shops,
        'staffs': this.staffs,
        'checkedStaffs': this.checkedStaffs,
        'currentShop': this.currentShop,
        'headers': this.headers,
        'shop': this.shop,
        'statuses': this.statuses,
        'checks': this.checks,
        'applieds': this.applieds,
      }
      const key = LOCAL_STORAGE_KEY + `${this.year}-${this.month}--${this.shop}`
      localStorage.setItem(key, JSON.stringify(data))
    },
    loadState () {
      const key = LOCAL_STORAGE_KEY + `${this.year}-${this.month}--${this.shop}`
      const data = JSON.parse(localStorage.getItem(key))
      if (!data) {
        return false
      }
      Object.keys(data).forEach(key => {
        this[key] = data[key]
      })
      return true
    },
    narrowStaff (val) {
      switch (val) {
        case 'inputOnly':
          let tmp = {}
          this.items.forEach(x => {
            x.plans.forEach(y => {
              tmp[y.staff] = 1
            })
          })
          this.checkedStaffs = Object.keys(tmp)
          break
        case 'myShop':
          this.checkedStaffs = this.staffs.filter(staff => staff.shop === this.currentShop).map(staff => staff.pk)
          break
        default:
          break
      }
    },
    shopChange (value) {
      this.fetchData()
    },
    refresh () {
      this.fetchShopData()
      this.fetchData()
    },
    fetchData () {
      if (!this.shop || this.isLoading) {
        return
      }
      this.isLoading = true
      this.currentShop = this.shop

      const fetchStaffData = this.$request.staffs.list(this.shop).then(res => {
        this.staffs = res.body.results

        const shop = this.currentShop
        const sFunc = function (a, b) {
          // 所属店舗の場合は一番上にする
          // 店舗が異なる場合は店舗コードで並び替える
          // 店舗が同じ場合はコード順で並び替える
          if (a.shop === shop && b.shop !== shop) {
            return -1
          } else if (a.shop !== shop && b.shop === shop) {
            return 1
          }
          if (a.shop !== b.shop) {
            return parseInt(a.shopCode) > parseInt(b.shopCode) ? 1 : -1
          }
          return (parseInt(a.code) > parseInt(b.code)) ? 1 : -1
        }
        this.staffs.sort(sFunc)

        let headers = []
        this.staffs.forEach((staff, index) => {
          headers.push({
            label: staff.name,
            staff: staff,
          })
        })
        this.headers = headers
        return res
      })

      let plannedStaff = {}
      const fetchPlans = this.$request.shifts.planList(this.shop, this.year, this.month).then(res => {
        let checks = {}
        let statuses = {}
        let applieds = {}
        res.body.results.forEach(x => {
          statuses[x.date] = x.status !== ShiftPlanStatus.NONE ? x.status : null
          checks[x.date] = x.isChecked
          applieds[x.date] = x.isApplied
          x.plans.forEach(tmp => {
            plannedStaff[tmp.staff] = 1
          })
        })
        this.statuses = statuses
        this.checks = checks
        this.applieds = applieds
        this.items = res.body.results
        return res
      })
      Promise.all([fetchStaffData, fetchPlans]).finally(() => {
        // 初期表示の作成 所属店舗もしくは予定が登録されている場合に表示
        let tmp = []
        this.staffs.forEach(staff => {
          if (staff.shop === this.shop || plannedStaff[staff.pk]) {
            tmp.push(staff.pk)
          }
        })
        this.checkedStaffs = tmp
        this.isLoading = false
      })
    },
    fetchShopData () {
      this.isLoading = true
      this.$request.shops.list().then(res => {
        this.shops = res.body.results.filter(x => x.shopType === ShopType.SHOP)
        const selectedShop = this.shops.find(x => x.pk === this.selectedShop)
        if (selectedShop) {
          this.shop = this.selectedShop
        }
      }).finally(() => {
        this.isLoading = false
        if (this.shop) {
          this.fetchData()
        }
      })
    },
    printDate (row, column, cellValue, index) {
      return moment(cellValue).locale('ja').format('DD (ddd)')
    },
    rowClass ({row, rowIndex}) {
      let ret = []
      const weekday = moment(row.date).weekday()
      if (weekday === 6) {
        ret.push('sat')
      } else if (weekday === 0) {
        ret.push('sun')
      }
      return ret
    },
    showStaffColumn (staff) {
      if (this.checkedStaffs.find(x => x === staff.pk)) {
        return true
      }
      return false
    },
    editable (date) {
      const row = this.items.find(x => x.date === date)
      if (row.isChecked || row.isApplied) {
        return false
      }
      return true
    },
    editPlan (date, staffData) {
      if (!this.editable(date)) {
        return
      }
      if (!this.shopData) {
        return
      }

      if (moment(this.shopData.shiftPlanEditableDate).isAfter(date)) {
        this.$message('登録可能日時をオーバーしています')
        return
      }
      let tmp = this.items.find(x => x.date === date)
      const planData = tmp ? tmp.plans.find(x => x.staff === staffData.pk) : null
      this.$refs.shiftEditDialog.show(date, staffData, planData)
    },
    editPlanWithoutStaff () {
      // 日付，スタッフ選択なしでの編集
      this.$refs.shiftEditDialog.showWithoutData()
    },
    editDone (data) {
      this.fetchData()
      // let tmp = this.items.find(x => x.date === data.date)
      // if (!tmp) {
      //   this.fetchData()
      //   return
      // }
      // if (data.shop === this.currentShop) {
      //   let planIdx = tmp.plans.findIndex(x => x.pk === data.pk)
      //   if (planIdx >= 0) {
      //     tmp.plans.splice(planIdx, 1, data)
      //   } else {
      //     tmp.plans.push(data)
      //   }
      // } else {
      //   let planIdx = tmp.helpPlans.findIndex(x => x.pk === data.pk)
      //   if (planIdx >= 0) {
      //     tmp.helpPlans.splice(planIdx, 1, data)
      //   } else {
      //     tmp.helpPlans.push(data)
      //   }
      // }
    },
    isOver (row) {
      let limitHour = this.dailyWorkingHourLimitation
      if (limitHour !== null) {
        let sum = row.plans.map(x => x.workMinutes).reduce((a, b) => a + b, 0) / 60
        if (sum > limitHour) return true
      }
      let limitStaff = this.staffCountLimitation
      if (limitStaff !== null) {
        let cnt = this.maxStaffCount(row)
        if (cnt > limitStaff) {
          return true
        }
      }
      return false
    },
    deleteDone (pk) {
      this.fetchData()
    },
    printPlan (row, staff) {
      const planData = row.plans.find(x => x.staff === staff.pk)
      if (!planData) {
        return '-'
      }
      if (planData.isVacation) {
        return '希望休'
      } else if (planData.isPaidVacation) {
        return '有給休暇'
      }
      const startMinute = zeroPadding(planData.startMinute)
      const endMinute = zeroPadding(planData.endMinute)
      let tmp = `${planData.startHour}:${startMinute} 〜 ${planData.endHour}:${endMinute}`
      if (planData.breakStartHour_1 && planData.breakEndHour_1) {
        const breakStartMinute = zeroPadding(planData.breakStartMinute_1)
        const breakEndMinute = zeroPadding(planData.breakEndMinute_1)
        let breakStr = `(${planData.breakStartHour_1}:${breakStartMinute} 〜 ${planData.breakEndHour_1}:${breakEndMinute})`
        tmp = tmp + '<br><span class="break-string">' + breakStr + '</span>'
      }

      if (planData.blockStartHour_1 && planData.blockEndHour_1) {
        const start = `${planData.blockStartHour_1}:${zeroPadding(planData.blockStartMinute_1)}`
        const end = `${planData.blockEndHour_1}:${zeroPadding(planData.blockEndMinute_1)}`
        let txt = `${start} 〜 ${end}`
        tmp += `<br><span class="break-string">予: ${txt}</span>`
      }
      if (planData.blockStartHour_2 && planData.blockEndHour_2) {
        const start = `${planData.blockStartHour_2}:${zeroPadding(planData.blockStartMinute_2)}`
        const end = `${planData.blockEndHour_2}:${zeroPadding(planData.blockEndMinute_2)}`
        let txt = `${start} 〜 ${end}`
        tmp += `<br><span class="break-string">予: ${txt}</span>`
      }
      return tmp
    },
    printHelpPlan (row, staff) {
      const planDataList = row.helpPlans.filter(x => x.staff === staff.pk)
      if (!planDataList) {
        return '-'
      }
      let tmp = ''
      planDataList.forEach(planData => {
        if (tmp) {
          tmp += '<br>'
        }
        if (planData.isVacation) {
          tmp += `希望休<br><span>${planData.shopName}</span>`
        } else if (planData.isPaidVacation) {
          tmp += `有給望休<br><span>${planData.shopName}</span>`
        } else {
          const startMinute = zeroPadding(planData.startMinute)
          const endMinute = zeroPadding(planData.endMinute)
          tmp += `${planData.startHour}:${startMinute} 〜 ${planData.endHour}:${endMinute}`
          tmp += `<br><span>${planData.shopName}</span>`
        }
      })
      return tmp
    },
    maxStaffCount (row) {
      let shift2dates = ({date, startHour, startMinute, endHour, endMinute}) => {
        let start = combineDatetime(date, startHour, startMinute)
        let end = combineDatetime(date, endHour, endMinute)
        if (start.isAfter(end)) {
          let tmp = start
          start = end
          end = tmp
        }
        let rval = {start, end}
        return rval
      }
      let shifts = row.plans.filter(x => !x.isVacation && !x.isPaidVacation).map(shift2dates)
      let start = combineDatetime(row.date, ...row.openTime.split(':'))
      let end = combineDatetime(row.date, ...row.closeTime.split(':'))
      let max = 0
      while (start.isSameOrBefore(end)) {
        let cnt = shifts.filter(x => start.isBetween(x.start, x.end)).length
        if (cnt > max) max = cnt
        start.add('minutes', 10)
      }
      return max
    },
    openingStaffNum (row) {
      let tmp = row.openTime.split(':')
      const openHour = parseInt(tmp[0])
      const openMinute = parseInt(tmp[1])

      let num = 0
      const openTime = openHour * 60 + openMinute
      row.plans.filter(plan => !plan.isVacation && !plan.isPaidVacation).forEach(plan => {
        const tmp = plan.startHour * 60 + plan.startMinute
        if (tmp <= openTime) {
          num++
        }
      })
      return num
    },
    closingStaffNum (row) {
      let tmp = row.closeTime.split(':')
      const closeHour = parseInt(tmp[0])
      const closeMinute = parseInt(tmp[1])

      let num = 0
      const closeTime = closeHour * 60 + closeMinute
      row.plans.filter(plan => !plan.isVacation && !plan.isPaidVacation).forEach(plan => {
        const tmp = plan.endHour * 60 + plan.endMinute
        if (tmp >= closeTime) {
          num++
        }
      })
      return num
    },
    workingTime (row) {
      let minutes = row.plans.filter(plan => !plan.isVacation && !plan.isPaidVacation && plan.workMinutes).map(plan => plan.workMinutes).reduce((a, b) => a + b, 0)
      return minutes / 60
    },
    shiftPlanStatusClass (row) {
      let ret = ''
      switch (row.status) {
        case ShiftPlanStatus.SHORTAGE:
          ret = 'shortage'
          break
        case ShiftPlanStatus.OVERAGE:
          ret = 'overage'
          break
        case ShiftPlanStatus.PENDDING:
          ret = 'pendding'
          break
        case ShiftPlanStatus.CHECKED:
          ret = 'checked'
          break
      }
      return ret
    },
    changeStatus (row, val) {
      this.$request.shifts.planCheckChange(this.currentShop, row.date, val).then(res => {
        const plan = this.items.find(x => x.date === row.date)
        plan.status = val
      }, err => {
        // エラーなので値をもとに戻す
        const plan = this.items.find(x => x.date === row.date)
        this.statuses[row.date] = plan.status !== ShiftPlanStatus.NONE ? plan.status : null
        if (err.response && err.response.body) {
          if (err.response.body.detail) {
            this.$message(err.response.body.detail)
          } else {
            let messages = []
            Object.keys(err.response.body).forEach(key => {
              messages.push(key + ': ' + err.response.body[key].join(', '))
            })
            this.$message(messages.join('\n'))
          }
        }
      })
    },
    showShiftApplyDialog () {
      this.$refs.shiftApplyDialog.show(this.year, this.month, this.currentShopData)
    },
  },
  filters: {
    locale (value, ...args) {
      if (value === null || value === undefined) return value
      return Number(value).toLocaleString(...args)
    },
  },
}
</script>

<style>
.staff-select > .el-transfer-panel {
  width: 300px;
}

.el-table tr.sat {
  background-color: #33ccdd6e;
}

.el-table tr.sun, .el-table tr.hol {
  background-color: #ee334469;
}

.el-table.shift-plan-table {
  font-size: small;
}

.el-table.shift-plan-table td {
  padding: 0;
}

.el-table.shift-plan-table th > div.cell,
.el-table.shift-plan-table td > div.cell {
  padding-left: 3px;
  padding-right: 3px;
}

.el-table.shift-plan-table td.working-time > div.cell {
  font-size: x-small;
  line-height: initial;
}

.break-string {
  font-size: x-small;
}

.shift-plan-status input.el-input__inner {
  font-size: x-small;
  padding: 0;
  text-align: center;
}

.shift-plan-status.checked input.el-input__inner {
  background-color: #64fe2e;
}
.shift-plan-status.shortage input.el-input__inner {
  background-color: #f78181;
}
.shift-plan-status.overage input.el-input__inner {
  background-color: #f5a9bc;
}
.shift-plan-status.pendding input.el-input__inner {
  background-color: #f4fa58;
}

.shift-plan-status .el-input__suffix {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/ShiftPlan/Index.vue